import { render, staticRenderFns } from "./addPlayerTalentSend.vue?vue&type=template&id=401e0f8b&scoped=true&"
import script from "./addPlayerTalentSend.vue?vue&type=script&lang=js&"
export * from "./addPlayerTalentSend.vue?vue&type=script&lang=js&"
import style0 from "./addPlayerTalentSend.vue?vue&type=style&index=0&id=401e0f8b&lang=stylus&scoped=true&"
import style1 from "./addPlayerTalentSend.vue?vue&type=style&index=1&lang=stylus&"
import style2 from "./addPlayerTalentSend.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401e0f8b",
  null
  
)

export default component.exports